import React from 'react';

import {colors} from 'styles/shared';

function Icon(props) {
  let color = props.color || colors.blue_main;

  return (
    <svg width="23" height="23" fill="none" viewBox="0 0 23 23">
      <path
        fill={color}
        d="M20.125 6.655H19.1a7.667 7.667 0 00-15.2 0H2.875A2.875 2.875 0 000 9.53v2.875a2.875 2.875 0 005.75 0V7.613a5.75 5.75 0 1111.5 0v8.625a2.875 2.875 0 01-2.875 2.875h-.177a2.875 2.875 0 100 1.917h.177a4.792 4.792 0 004.792-4.792v-.958h.958A2.875 2.875 0 0023 12.405V9.53a2.875 2.875 0 00-2.875-2.875zm-16.292 5.75a.958.958 0 01-1.916 0V9.53a.958.958 0 01.958-.959h.958v3.834zM11.5 21.03a.958.958 0 110-1.917.958.958 0 010 1.917zm9.583-8.625a.958.958 0 01-.958.958h-.958V8.571h.958a.958.958 0 01.958.959v2.875z"></path>
    </svg>
  );
}

export default Icon;
